export default __webpack_public_path__ + "static/sales-image-9639ede7b2c6d3d869e31d8dd8a0aba0.jpg";